<template>
  <div>
    <iframe style="width:100%;height:500px" src="https://flbook.com.cn/c/AefbjYrQi6" seamless="seamless" scrolling="no"
      frameborder="0" allowtransparency="true" allowfullscreen="true"></iframe>
    <!-- <iframe :src="magazinePath" frameborder="0" style="width: 100%; height: 700px;"></iframe> -->
  </div>
</template>

<script>
import { getMagazineDetails } from "@/assets/api/magazine.js";
export default {
  data() {
    return {
      magazineId: '',
      magazinePath: '',
    };
  },
  created() {
    this.magazineId = localStorage.getItem('magazineId')
    getMagazineDetails(this.magazineId).then((res) => {
      // console.log(res.data)
      this.magazinePath = res.data.data.url
    });
  },
  mounted() {
  },
  beforeDestroy() {
  },
  methods: {

  }
};
</script>

<style scoped>
.ebook-container {
  margin: 20px auto;
}

.controls {
  margin-top: 10px;
  text-align: center;
}

.epub-container::-webkit-scrollbar {
  display: none;
}

/* 添加触摸优化样式 */
.ebook-container {
  touch-action: pan-y;
  /* 保留垂直滚动能力 */
  overflow: hidden;
  /* 防止容器内出现滚动条 */
  -webkit-overflow-scrolling: touch;
  /* iOS平滑滚动 */
}

.ebook-container {
  transition: transform 0.3s ease;
}

.page-slide-enter {
  transform: translateY(100%);
}

.page-slide-leave-to {
  transform: translateY(-100%);
}

/* 禁用滚动条 */
html,
body {
  overflow: hidden;
}

/* 确保元素可以接收触摸事件 */
.touch-area {
  touch-action: manipulation;
}
</style>


// WEBPACK FOOTER //
// src/views/magazine-preview/index.vue